import React, { useReducer, createContext, useState, useEffect } from 'react'
import httpClient from 'utility/httpClient.util'
import Swal from 'sweetalert2'
import moment from 'moment'
import { method } from 'lodash'
const initail = {
  jsonForm: {
    schema: {},
    uischema: {},
  },
  Query: '',
  params: {},
  dataPreview: [],
  onclickData: {},
  selectedData: [],
}

const Context = createContext(initail)

const ExportReducer = (state, { type, payload }) => {
  switch (type) {
    case 'SET_SCHEMA':
      return { ...state, jsonForm: { ...state.jsonForm, schema: payload } }

    case 'SET_UISCHEMA':
      return { ...state, jsonForm: { ...state.jsonForm, uischema: payload } }
    case 'REMOVE_ELEMENT':
      return { ...state, jsonForm: { ...state.uischema, elements: payload } }
    case 'SET_DATA':
      return { ...state, jsonForm: payload }
    case 'SET_QUERY':
      return { ...state, Query: payload }
    case 'SET_PARAMS':
      return { ...state, params: payload }
    case 'SET_DATAPREVIEW':
      return { ...state, dataPreview: payload }
    case 'SET_DATACLICK':
      return { ...state, onclickData: payload }

    case 'SET_SELECTED':
      return { ...state, selectedData: payload }
    default:
      return state
  }
}

const ExportProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ExportReducer, initail)
  const [exportID, setExportID] = useState()
  const [UrlProcess, seturlProcess] = useState('')
  const [group, setGroup] = useState('')
  const [exportTemplateDataFileId, setExportTemplateDataFileId] = useState(null)
  const [exportTemplateJobId, setExportTemplateJobId] = useState('')

  const [layoutPreview, setLayoutPreview] = useState(false)

  const [StateChange, setStateChange] = useState(0)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [total, setTotal] = useState(0)
  const [exportType, setExportType] = useState('')
  const [preview, setPreview] = useState([])
  const [statusDownload, setStatusDownload] = useState(false)
  const [selectInput, setSelectInput] = useState([])
  const [statusProcess, setStatusProcess] = useState(false)
  const [runIn, setRunIn] = useState(0)
  const [remainingTime, setRemainingTime] = useState(0)
  const [loading, setLoading] = useState(false)
  const [fileZipName, setFileZipName] = useState('')
  const [displayButtonApi, setDisplayButtonApi] = useState(false)
  const [isDownloadingExport, setIsDownloadingExport] = useState(false)
  const setChange = () => {
    setStateChange(StateChange + 1)
  }

  const setSelected = (payload) => {
    dispatch({ type: 'SET_SELECTED', payload })
  }

  const setSchema = (payload) => {
    dispatch({ type: 'SET_SCHEMA', payload })
  }

  const setUiSchema = (payload) => {
    dispatch({ type: 'SET_UISCHEMA', payload })
  }

  const setData = (payload) => {
    dispatch({ type: 'SET_DATA', payload })
  }

  const setQueryData = (payload) => {
    dispatch({ type: 'SET_QUERY', payload })
  }

  const setParams = (payload) => {
    dispatch({ type: 'SET_PARAMS', payload })
  }

  const setDataPreview = (payload) => {
    dispatch({ type: 'SET_DATAPREVIEW', payload })
  }

  const setDataClick = (payload) => {
    dispatch({ type: 'SET_DATACLICK', payload })
  }

  const {
    jsonForm,
    Query,
    params,
    dataPreview,
    onclickData,
    selectedData,
  } = state
  const { uischema } = jsonForm
  const { elements } = uischema

  const removeObject = (id) => {
    const NewArr = removeObjectId(id)
    if (selectedData.length != 0) {
      const SelectedNew = removeSelected(id)
      setSelected(SelectedNew)
    }
    let payload = { type: 'HorizontalLayout', elements: NewArr }
    dispatch({ type: 'SET_UISCHEMA', payload })
    //console.log("new data", state);
    //console.log(NewArr);
    setDataClick('')
  }

  function removeObjectId(id) {
    const arrCopy = Array.from(uischema.elements)
    const objWithIdIndex = arrCopy.findIndex((obj) => obj.id === id)
    arrCopy.splice(objWithIdIndex, 1)

    return arrCopy
  }

  function removeSelected(id) {
    const arrayCopy = Array.from(selectedData)
    const objectIdIndex = arrayCopy.findIndex((obj) => obj.id === id)
    arrayCopy.splice(objectIdIndex, 1)

    return arrayCopy
  }

  const updateValue = (dataUpdate, id, value) => {
    const newElements = uischema.elements?.map((obj) => {
      if (obj.id === id) {
        if (dataUpdate === 'value') {
          return { ...obj, value: value }
        }
        if (dataUpdate === 'label') {
          return { ...obj, label: value }
        }
        if (dataUpdate === 'placeholder') {
          return { ...obj, placeholder: value }
        }
        if (dataUpdate === 'clicked') {
          return { ...obj, clicked: value }
        }

        if (dataUpdate === 'name') {
          return { ...obj, name: value }
        }
        if (dataUpdate === 'backText') {
          return { ...obj, backText: value }
        }

        if (dataUpdate === 'required') {
          return { ...obj, required: value }
        }
        if (dataUpdate === 'defaultvalue') {
          return { ...obj, defaultvalue: value }
        }
        if (dataUpdate === 'readonly') {
          return { ...obj, readonly: value }
        }
        if (dataUpdate === 'dateDefaultType') {
          return { ...obj, dateDefaultType: value }
        }
        if (dataUpdate === 'colum') {
          return { ...obj, column: value }
        }
        if (dataUpdate === 'border') {
          return { ...obj, border: value }
        }
        if (dataUpdate === 'helpData') {
          return { ...obj, helpData: value }
        }
        if (dataUpdate === 'helpIcon') {
          return { ...obj, helpIcon: value }
        }
        if (dataUpdate === 'input') {
          return { ...obj, ...value }
        }
        if (dataUpdate === 'methods') {
          return { ...obj, methods: value }
        }
        if (dataUpdate === 'endpoint') {
          return { ...obj, endpoint: value }
        }
      } else {
        if (dataUpdate === 'clicked') {
          return { ...obj, clicked: false }
        }
      }
      if (id === '') {
        if (dataUpdate === 'colum') {
          return { ...obj, column: value }
        }
      }

      return obj
    })

    let payload = { type: 'HorizontalLayout', elements: newElements }
    dispatch({ type: 'SET_UISCHEMA', payload })
    console.log('updated parameter', newElements)
  }

  const onclickElement = (data) => {
    setDataClick(data)
    updateValue('clicked', data.id, true)
  }

  const handleOnDragEnd = (result) => {
    if (!result.destination) return

    const items = Array.from(uischema.elements)
    const [reorderedItem] = items.splice(result.source.index, 1)
    items.splice(result.destination.index, 0, reorderedItem)
    let payload = { type: 'HorizontalLayout', elements: items }
    dispatch({ type: 'SET_UISCHEMA', payload })
  }

  const getDateDefaultValue = (item) => {
    switch (item?.dateDefaultType) {
      case 'currentDate':
        return moment().format('YYYY-MM-DD')
      case 'firstDayOfMonth':
        return moment().startOf('month').format('YYYY-MM-DD')
      case 'lastDayOfMonth':
        return moment().endOf('month').format('YYYY-MM-DD')
      case 'none':
        return ''
      default:
        return item?.value
    }
  }

  const buildParams = () => {
    let newParam = {}
    uischema.elements?.forEach((item) => {
      if (item.input === 'text') {
        Object.assign(newParam, { [item.name]: item.value })
      }
      if (item.input === 'date') {
        Object.assign(newParam, { [item.name]: getDateDefaultValue(item) })
      }
    })

    selectInput?.forEach((item) => {
      if (item.value !== '0') {
        Object.assign(newParam, { [item.name]: item.value })
      }
    })

    return newParam
  }

  const getParams = () => {
    const newParam = buildParams()
    setParams(newParam)
    return newParam
  }

  //by exportJobFile
  const previewData = async () => {
    if (page !== null) {
      setLoading(true)
      try {
        const currentParams = getParams()
        if (exportTemplateDataFileId) {
          await httpClient
            .get(
              `/Report/export-template-data-file/${exportTemplateDataFileId}/preview-data?page=${page}&perPage=${pageSize}&params=${JSON.stringify(
                currentParams,
              )}`,
            )
            .then((res) => {
              const data = res?.data?.data
              const pagination = res.data.meta.pagination
              setDataPreview(data)
              setTotal(pagination.total)
              setLoading(false)
            })
        }
      } catch (error) {
        // Swal.fire({
        //   icon: "error",
        //   title: "เกิดข้อผิดพลาด",
        //   text: error?.response?.data?.message,
        // });
      } finally {
        setLoading(false)
      }
    }
  }

  const resetData = () => {
    setPreview([])
  }

  useEffect(() => {
    getParams()
  }, [selectInput])

  useEffect(() => {
    getParams()
  }, [elements])

  //get query template

  const getQueryTemplate = async () => {
    try {
      const body = { params: params, query: Query }

      await httpClient
        .post(
          `/Report/export-template/${exportID}/query?page=${page}&perPage=${pageSize}`,
          body,
        )
        .then((res) => {
          const data = res?.data?.data
          setDataPreview(data)
          const totalData = res?.data?.meta?.pagination?.total
          setTotal(totalData)
        })
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: error.response.data.message,
      })
    }
  }

  //by export-templateID
  const previewExportFileData = async (id, query) => {
    if (page !== null) {
      try {
        const currentParams = getParams()
        const res = await httpClient.get(
          `/Report/export-template/${exportID}/preview-data?page=${page}&perPage=${pageSize}&params=${JSON.stringify(
            currentParams,
          )}`,
        )
        if (res.status === 200) {
          const data = res?.data.data[0].data
          const totalPage = res?.data.data[0].pagination?.totalPage

          setTotal(totalPage)

          setDataPreview(data)
        } else {
          setDataPreview([])
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: error.response?.data?.message || error.message,
        })
      }
    }
  }

  const [sortList, setSortList] = useState([])
  const sortExportFileData = async (orderBy, orderDirection) => {
    setSortList((prevSortList) => {
      const newSortList = {
        ...prevSortList,
        [orderBy]: orderDirection,
      }

      if (page !== null) {
        try {
          const currentParams = getParams()
          httpClient
            .get(
              `/Report/export-template/${exportID}/preview-data?page=${page}&perPage=${pageSize}&params=${JSON.stringify(
                currentParams,
              )}
              &sort=${JSON.stringify(newSortList)}`,
            )
            .then((res) => {
              if (res.status === 200) {
                const data = res?.data.data[0].data
                const totalData = res?.data.data[0].pagination?.total
                setTotal(totalData)
                setDataPreview(data)
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: error.response.data.message,
              })
            })
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: error.response.data.message,
          })
        }
      }
      return newSortList
    })
  }

  const getDownloadExtension = (mime) => {
    const value = String(mime || "").toLowerCase()
    if (value.includes("dbf")) return "dbf"
    if (value.includes("zip")) return "zip"
    if (value.includes("csv")) return "csv"
    if (value.includes("spreadsheet") || value.includes("excel")) return "xlsx"
    if (value.includes("xml")) return "xml"
    if (value.includes("plain")) return "txt"
    return ""
  }

  const cleanDownloadFileName = (fileName) => {
    return String(fileName || "").replace(/[\\/:*?"<>|]/g, "_")
  }

  const getDownloadFileName = (fileName, fallbackName, mime) => {
    const value = cleanDownloadFileName(fileName).trim()
    const fallback = cleanDownloadFileName(fallbackName).trim() || "export"
    const downloadName =
      value && !/^(undefined|null)(\.[^./\\]+)?$/i.test(value)
        ? value
        : fallback

    if (/\.[^./\\]+$/.test(downloadName)) return downloadName

    const extension = getDownloadExtension(mime)
    return extension ? downloadName + "." + extension : downloadName
  }

  const getFormattedFileNameParam = (value, format) => {
    const rawValue = String(value ?? "")
    const dateFormat = String(format || "").trim()
    if (!dateFormat || !rawValue) return rawValue

    const dateValue = moment(
      rawValue,
      [moment.ISO_8601, "YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY"],
      true,
    )
    if (!dateValue.isValid()) return rawValue

    const buddhistYear = dateValue.year() + 543
    const momentFormat = dateFormat.replace(/BBBB/g, "[" + buddhistYear + "]")
    return dateValue.format(momentFormat)
  }

  const getFileNameFromParams = (fileName, paramValue = {}) => {
    if (!fileName) return ""
    return String(fileName).replace(/\$\{([^}]+)\}/g, (word, key) => {
      const pattern = String(key || "").trim()
      const formatIndex = pattern.indexOf(":")
      const paramKey = formatIndex > -1 ? pattern.slice(0, formatIndex).trim() : pattern
      const dateFormat = formatIndex > -1 ? pattern.slice(formatIndex + 1).trim() : ""
      if (!paramKey) return ""
      return Object.prototype.hasOwnProperty.call(paramValue, paramKey)
        ? getFormattedFileNameParam(paramValue[paramKey], dateFormat)
        : word
    })
  }

  const getFile = async (attachmentId, name, fallbackName = "export") => {
    const originFileName = name
    try {
      const response = await httpClient.get(
        `/media/attachment/download/${attachmentId}`,
        {
          cache: false,
          responseType: 'blob',
        },
      )
      const mime =
        response.headers?.['content-type'] || 'application/octet-stream'
      const downloadName = getDownloadFileName(originFileName, fallbackName, mime)
      const blob = new Blob([response.data], { type: mime })
      const blobUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobUrl
      a.setAttribute('download', downloadName)
      document.body.appendChild(a)
      a.click()
      window.setTimeout(() => {
        if (a.parentNode) document.body.removeChild(a)
        window.URL.revokeObjectURL(blobUrl)
      }, 1500)
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาดในการดาวน์โหลด',
        text: error.response?.data?.message || 'ไม่สามารถดาวน์โหลดไฟล์ได้',
      })
    }
  }

  const downloadExport = async () => {
    if (statusDownload) {
      if (!exportType) {
        Swal.fire({
          icon: 'error',
          title: 'กรุณาเลือกประเภทของ SupportFile ก่อนดาวน์โหลด',
        })
        return
      }
      setIsDownloadingExport(true)
      try {
        const currentParams = buildParams()
        setParams(currentParams)
        const res = await httpClient
          .get(`/report/export-template/${exportID}/formats/${exportType}/download`, {
            cache: false,
            params: {
              params: JSON.stringify(currentParams),
            },
          })
          .then(({ data }) => data)
        const attachmentId = res.data.attachmentId
        const responseName = res.data.fileName || res.data.filename || res.data.file_name || res.data.name
        const zipFileName = getFileNameFromParams(fileZipName, currentParams)
        const name = zipFileName || getFileNameFromParams(responseName, currentParams)
        const fallbackName = zipFileName || `export_${exportID}`
        await getFile(attachmentId, name, fallbackName)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาดในการดาวน์โหลด ExportTemplate',
          text: error.response?.data?.message || error.message,
        })
      } finally {
        setIsDownloadingExport(false)
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'ExportTemplate ยังไม่พร้อมดาวน์โหลด',
      })
    }
  }

  const processTemplateExport = async () => {
    if (runIn === 1) {
      setDisplayButtonApi(false)
      setStatusDownload(false)
      setRemainingTime(0)
      if (!exportType) {
        Swal.fire({
          icon: 'error',
          title: 'กรุณาเลือกประเภทของ SupportFile ก่อนประมวลผล',
        })
        return
      }

      try {
        const currentParams = getParams()
        let body = { params: currentParams }
        const url = `/report/export-template/${exportID}/formats/${exportType}/queue`
        const res = await httpClient
          .post(url, body)
          .then((response) => response.data.data)
        setStatusProcess(true)
        if (res) {
          console.log(res?.exportTemplateJobId)
          setExportTemplateJobId(res?.exportTemplateJobId)
          Swal.fire({
            icon: 'success',
            title: 'กำลังเข้าสู่กระบวนการโปรเซสข้อมูล',
            timer: 1500,
            showConfirmButton: false,
          })
        }
        setChange()
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาดในการ process',
          text: error.response.data.message,
        })
      }
    }
  }

  const processDataFile = async () => {
    if (runIn === 1) {
      try {
        const currentParams = getParams()
        let body = { params: currentParams }
        const url = `/report/export-template-data-file/${exportTemplateDataFileId}/formats/${exportType}/queue`
        const res = await httpClient
          .post(url, body)
          .then((response) => response.data.data)
        if (res) {
          Swal.fire({
            icon: 'success',
            title: 'โปรเซสข้อมูลไฟล์สำเร็จ',
          })
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาดในการ process',
          text: error.response.data.message,
        })
      }
    }
  }

  const handlePageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value, 10))
    setPage(1)
  }

  const handelChange = (e, id, name) => {
    setSelectInput((prevState) => {
      const existingIndex = prevState.findIndex((item) => item.id === id)
      if (existingIndex !== -1) {
        const updatedState = [...prevState]
        updatedState[existingIndex] = { id: id, value: e.value, name: name }
        return updatedState
      } else {
        return [...prevState, { id: id, value: e.value, name: name }]
      }
    })
  }

  return (
    <Context.Provider
      value={{
        ...state,
        getParams,
        setExportID,
        seturlProcess,
        UrlProcess,
        onclickData,
        elements,
        setSchema,
        setUiSchema,
        onclickElement,
        removeObject,
        handleOnDragEnd,
        updateValue,
        setData,
        setTotal,
        previewData,
        setQueryData,
        setParams,
        setDataClick,
        setSelected,
        setDataPreview,
        downloadExport,
        processTemplateExport,
        processDataFile,
        handelChange,
        setChange,
        StateChange,
        Query,
        params,
        dataPreview,
        selectedData,
        group,
        setGroup,
        previewExportFileData,
        setExportTemplateDataFileId,
        setPageSize,
        pageSize,
        setPage,
        page,
        total,
        getQueryTemplate,
        handlePageSizeChange,
        resetData,
        setExportType,
        sortExportFileData,
        statusDownload,
        statusProcess,
        setStatusDownload,
        selectInput,
        layoutPreview,
        setLayoutPreview,
        exportTemplateDataFileId,
        setRunIn,
        runIn,
        setStatusProcess,
        exportTemplateJobId,
        remainingTime,
        setRemainingTime,
        loading,
        setFileZipName,
        fileZipName,
        setDisplayButtonApi,
        displayButtonApi,
        isDownloadingExport,
        getFileNameFromParams,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export { Context, ExportProvider }
